export const API_ENDPOINTS = {
  // CONTENT
  MAIN_SLIDERS: `/main/slider/`,
  MAIN_ICONS: `/main/icon/`,
  FAQS: `/faq/faq/`,
  WHY_FOREVER: `/whyforever/page/`,
  INCENTIVES: `/incentive/page/`,
  PROMOTIONS: `/promo/page/`,
  EVENTS: `/event/page/`,
  CATALOGUE: `/catalogue/catalogue/`,
  MAGAZINES: `/magazine/magazine/`,
  UPLOAD_CATEGORY: `/upload/category/`,
  UPLOAD_UPLOAD: `/upload/upload/`,
  COMMON_VARS: `/common/variables/`,
  COMMON_MESSAGE: `/common-message/`,
  NEWS: `/v2/news/list/`,
  NEWS_CONTENT: `/v2/news/retrieve/`,
  REGION: `/location/region/`,
  STORIES: `/stories/`,
  
  // AUTH & USER
  LOGIN: `/login/`,
  REGISTER: `/users/`,
  LOGOUT: `/logout`,
  FORGET_PASSWORD: `/password/reset/`,
  CHANGE_PASSWORD: `/users/change-password/`,
  SPONSOR_ID: `/users/check-sponsor/`,
  FEEDBACK: `/feedback/feedback/`,
  RESET_PASSWORD: `/password/change/`,
  AUTO_LOGIN: `/token/auto-login/`,

  // PRODUCTS
  MAIN_PRODUCTS: `/v2/catalog/product/list/`,
  CATEGORIES: `/v2/catalog/category/list/`,
  PRODUCTS: `/v2/catalog/product/list/`,
  PRODUCT_DETAILS: `/product/`,

  // SHOP & CHECKOUT
  SEARCH: `/product/?limit=9&offset=0&q=`,
  USER_ADDRESS: `/users/address/`,
  USER_ADD_ADDRESS: `/users/add-address/`,
  USER_ADDRESS_CREATE: `/v2/user/address/create/`,
  USER_DELETE_ADDRESS: `/users/delete-address/`,
  USER_UPDATE_ADDRESS: `/address/`,
  CREATE_ORDER: `/order/order/`,

  // SHOPPING CART
  MINI_CART: `/v2/order/cart/short/`,
  ADD_TO_CART: `/v2/order/cart/add/`,
  REMOVE_FROM_CART: `/v2/order/cart/remove/`,
  UPDATE_CART: `/v2/order/cart/update/`,
  CART_LIST: `/v2/order/cart/list`,
  CART_CREATE: `/v2/order/cart/create/`,
  CLEAN_CART: `/v2/order/cart/clean/`,
  // CART_DETAIL: (pk: number) => `/api/order/cart/${pk}/`,
  CARGO_MESSAGE: `/common/cargo-message/`,
  DELETE_CART: `/v2/order/cart/delete/`,
  OPERATION_MONTH: `/common/operation-month/`,
  GUEST_CART_LIST: `/v2/order/cart/list/?cart_id=`,
  TR_BIN_CARD: (orderCode: number, bin: string) => `/v2/payment/tr/card/bin/check/${orderCode}/?bin=${bin}`,
  CONSOLIDATE_ORDER:(orderCode: number) => `/v2/order/get/${orderCode}/`,
  
  // USER PROFILE
  ORDERS: `/order/history/?limit=20&offset=0&source=main`,
  RETAIL_ORDERS: `/order/retail-history/?limit=20&offset=0`,
  ORDER: (id: string) => `/order/history/${id}`,
  ACCOUNTDETAIL: `/users/`,
  ADDRESSDISTRICTS: `/districts/`,
  ADDRESSPROVINCE: `/provinces/`,
  RETAIL: `/users/retail/`,
  RETAILUPDATE: `/retail/retail/`,
  USERLIMITS: `/user/limits/`,
 // KG_DOCUMENTS: `/kg/check/documents/`,

  // COMMON
  ALL_COUNTRIES: `/confs/allcountries/`,

  // POPULAR_PRODUCTS: "/v2/catalog/product/list/?is_popular=1",
  // NEW_ARRIVAL_PRODUCTS: "/v2/catalog/product/list/?new=1",
  // PROMO_PRODUCTS: "/v2/catalog/product/list/?is_promo=1",
};
